import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";
import { Flex, TruncatedText } from "@similarweb/ui-components/foundations";

// We remove the border and spacing around the icon
export const WebsiteIcon = styled(ItemIcon)`
    width: auto;
    height: auto;
    border: none;
`;

export const TruncatedNameText = styled(TruncatedText)`
    max-width: 300px;
`;

export const VerticalDivider = styled.div`
    width: 1px;
    height: 12px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const DropdownTrigger = styled(Flex)`
    cursor: pointer;
    user-select: none;
    align-items: center;
    gap: 6px;
`;
